module.exports = __webpack_public_path__ + "static/img/move.f840210e.svg";